import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SidenavItem } from 'src/app/layout/sidenav/sidenav-item/sidenav-item.interface';
import { SidenavNavigationData } from 'src/app/layout/sidenav/sidenav.data';

@Component({
  selector: 'fury-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  private static isInitialLoad = true;
  gap = 16;

  public items: any[] = [];
  public appName = 'Adaptiv-AI';

  constructor(
    private router: Router,
    private sidenavNavigationData: SidenavNavigationData
  ) {
    /**
     * Edge wrong drawing fix
     * Navigate anywhere and on Promise right back
     */
    if (/Edge/.test(navigator.userAgent)) {
      if (DashboardComponent.isInitialLoad) {
        this.router
          .navigate(['/apps/chat'])
          .then(() => {
            this.router.navigate(['/']).catch((error) => {
              console.warn(error);
            });
          })
          .catch((error) => {
            console.warn(error);
          });

        DashboardComponent.isInitialLoad = false;
      }
    }
  }

  ngOnInit(): void {
    this.items = this.flattenNavigationItems(this.sidenavNavigationData.navigationAppItems)
      .filter((item: SidenavItem) => item.routeOrFunction)
      .map((item: SidenavItem) => ({
        link: item.routeOrFunction,
        icon: item.icon,
        title: item.name,
        subtitle: `Accéder à la section ${item.name}`
      }));
  }

  private flattenNavigationItems(items: SidenavItem[]): SidenavItem[] {
    return items.flatMap((item) => (item.subItems?.length ? this.flattenNavigationItems(item.subItems) : item));
  }
}
